<div id="top"></div>
<section class="utility--menu-position-absolute">
  <div class="container">
    <div class="row">
      <div class="col-7 col-md-4 col-xl-3 align-self-center menu-logo">
        <a routerLink="/">
          <img class="menu-logo__logo" src="assets/images/logo-white.svg" alt="logo" />
        </a>
      </div>
      <div class="col-5 col-md-8 col-xl-9 align-self-center">
        <ng-content select="div.mobile-menu"></ng-content>

        <ng-content select="nav.main-menu"></ng-content>
      </div>
    </div>
  </div>
</section>
<div class="layout-content">
  <ng-content></ng-content>
</div>
<app-footer></app-footer>
